import { useUpdateUserIntegrationModal } from '@/features/update-user-integration'
import EditSvg from '@/shared/assets/images/Pencil.svg'
import { useAppDispatch, useAppSelector } from '@/shared/lib/redux'
import { fetchUserIntegration, selectUserIntegration } from '../../model'

export const UpdateIntegration = () => {
    const { openUpdateUserIntegrationModal } = useUpdateUserIntegrationModal()
    const integration = useAppSelector(selectUserIntegration)
    const dispatch = useAppDispatch()

    const onUpdate = () => {
        dispatch(fetchUserIntegration())
    }

    return (
        <button onClick={() => openUpdateUserIntegrationModal(integration, onUpdate)}>
            <EditSvg width={20} height={20} />
        </button>
    )
}